import { useEffect } from 'react';
import useApi from './useApi';
import { useToast } from '../app/useToast';
import useApiEndpoints from '../context/useApiEndpoints';
import { useUserSettingsStore } from '../context/UserSettingsContext';
import { UserSettings } from '../types/ViewModel/UserSettings';
import { UserSettingsBM } from '../types/BusinessModel/UserSettingsBM';
import { buildQueryParams } from './endpoints/queryParamsHelper';
import { useAuthStore } from '../context/AuthContext';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';

export default () => {
    const { apiEndpoints } = useApiEndpoints();
    const { state, getApiData, postApiData } = useApi();
    const { loggedInUser } = useAuthStore();
    const { setUserSettings, setUserSettingsLoaded } = useUserSettingsStore();
    const { processApiEndpointError } = apiEndpointUtils();

    const getUserSettings = () => {
        if (loggedInUser?.appAccessToken) {
            const windowParams = new URLSearchParams(window.location.search);
            const imoNumberStr = windowParams.get('imoNumber');
            if (!imoNumberStr) return;
            getApiData({
                endpoint: apiEndpoints['getUserSettings'].url,
                queryParam: buildQueryParams({ imoNumber: imoNumberStr }),
            });
        } else {
            getApiData({
                endpoint: apiEndpoints['getUserSettings'].url,
            });
        }
    };

    const upsertUserSettings = (newUserSettings: UserSettings) => {
        if (loggedInUser?.appAccessToken) {
            const windowParams = new URLSearchParams(window.location.search);
            const imoNumberStr = windowParams.get('imoNumber');
            if (!imoNumberStr) return;
            postApiData({
                endpoint: apiEndpoints['setUserSettings'].url,
                queryParam: buildQueryParams({ imoNumber: imoNumberStr, ...newUserSettings }),
                callInBackground: true,
            });
        } else {
            postApiData({
                endpoint: apiEndpoints['setUserSettings'].url,
                queryParam: buildQueryParams(newUserSettings),
                callInBackground: true,
            });
        }
    };

    useEffect(() => {
        if (state.status === 'success') {
            const userSettingsBM = state.result as unknown as UserSettingsBM;
            const userSettings = new UserSettings(
                userSettingsBM?.aolPeriod && userSettingsBM?.aolPeriod !== 'null' ? userSettingsBM?.aolPeriod : null,
                // if user setting for sort is null (not set by user), default to true.
                userSettingsBM?.sortAsc === null || userSettingsBM?.sortAsc
            );
            setUserSettings(userSettings);
            setUserSettingsLoaded(true);
        } else {
            processApiEndpointError(state);
        }
    }, [state]);

    return { state, getUserSettings, upsertUserSettings };
};
